module.exports = __webpack_public_path__ + "img/Authority.9371ab74.svg";